import React, { Component } from 'react';
import propTypes from 'prop-types';
import './NoScrollBar.scss';

import withScrolling from './react-dnd-scrollzone';

const ScrollComponent = withScrolling('div');

const BUFFER = 100;

const vStrength = function(box, point) {
  let { x, y, w, h } = box;
  const buffer = Math.min(h / 2, BUFFER);
  const inRange = point.y >= y && point.y <= y + h;
  const inBox = inRange && point.x >= x && point.x <= x + w;

  if (inBox) {
    if (point.y < y + buffer) {
      return (point.y - y - buffer) / buffer / 2;
    } else if (point.y > y + h - buffer) {
      return -(y + h - point.y - buffer) / buffer / 2;
    }
  } else {
    if (point.y < y + buffer) {
      return Math.max(-1, (point.y - y - buffer) / buffer) / 2;
    } else if (point.y > y + h - buffer) {
      return Math.min(1, -(y + h - point.y - buffer) / buffer) / 2;
    }
  }

  return 0;
};

var hasMouseWheel = false;

window.addEventListener('wheel', () => (hasMouseWheel = true));

class NoScrollBar extends Component {
  showScrollBar = () => {
    if (this.props.showScrollOnHover && !hasMouseWheel) {
      this.scrollRef.wrappedInstance.style.right = 0;
    }
  };

  hideScrollBar = () => {
    if (this.scrollRef) {
      this.scrollBarWidth =
        this.scrollRef.wrappedInstance.clientWidth -
        this.scrollRef.wrappedInstance.offsetWidth +
        'px';
      this.scrollRef.wrappedInstance.style.right = this.scrollBarWidth;
    }
  };

  componentDidMount = () => {
    this.hideScrollBar();
    setTimeout(() => this.hideScrollBar());
  };

  componentDidUpdate = () => {
    this.hideScrollBar();
    setTimeout(() => this.hideScrollBar());
  };

  render() {
    const { children, disable } = this.props;
    if (disable) return children;
    const childDiv = (
      <ScrollComponent
        verticalStrength={vStrength}
        onMouseOver={this.showScrollBar}
        onMouseLeave={this.hideScrollBar}
        ref={r => {
          this.scrollRef = r;
        }}
        className="scroll-child"
      >
        {children}
      </ScrollComponent>
    );
    this.hideScrollBar();
    return <div className="scroll-parent"> {childDiv} </div>;
  }
}

NoScrollBar.propTypes = {
  children: propTypes.node,
  showScrollOnHover: propTypes.bool,
  disable: propTypes.bool,
};

NoScrollBar.defaultProps = {
  showScrollOnHover: true,
  disable: false,
};

export default NoScrollBar;
